import { CONTRACTOR_WO_PRIORITIES_CRUD_ACTION_CREATORS } from '../actions/contractor_wo_priorities_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

export const contractorWOPrioritiesRestCrudThunksForBuyer = new RestCrudThunks(
	'contractor_work_order_priorities',
	'contractor_work_order_priority',
	'contractorWOPriority',
	'contractorWOPriorities',
	CONTRACTOR_WO_PRIORITIES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'work_order/'
);
export const contractorWOPrioritiesRestCrudThunksForSupplier = new RestCrudThunks(
	'contractor_work_order_priorities',
	'contractor_work_order_priority',
	'contractorWOPriority',
	'contractorWOPriorities',
	CONTRACTOR_WO_PRIORITIES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'work_order/'
);
